module.exports = __webpack_public_path__ + "static/media/bg.b60bf4d4.png";